import React, { useEffect, useState } from 'react';
import api from '../api/client';

let cache: Promise<any[]> | null = null;

/** Company payment accounts, shown under the document header */
const PaymentDetails: React.FC = () => {
  const [accounts, setAccounts] = useState<any[]>([]);
  useEffect(() => {
    if (!cache) cache = api.get('/settings/payment-accounts').then(r => (r.data.data || []).filter((a: any) => a.show)).catch(() => []);
    cache.then(setAccounts);
  }, []);
  if (!accounts.length) return null;
  return (
    <div style={{ fontSize: 11, padding: '4px 0 8px', marginBottom: 8, borderBottom: '1px solid #ccc', color: '#222' }}>
      <strong>Lacag bixinta / Payment details:</strong>{' '}
      {accounts.map((a, i) => (
        <span key={i}>{i > 0 && ' · '}{a.label}: <span style={{ fontFamily: 'monospace' }}>{a.number}</span>{a.holder ? ` (${a.holder})` : ''}</span>
      ))}
    </div>
  );
};
export default PaymentDetails;
